export default __webpack_public_path__ + "src/images/text_sidebar/2-b6fd0c.png";